import bidello, { component } from '../bidello'

import './helpers/viewport'
import './helpers/pointer'
import './helpers/raf'

import renderer from './renderer'
import scene from './scene'
import camera from './camera'
import postfx from './postfx/postfx'

import world from './world/world'
import { raf } from './helpers/raf'
import assets from './assets'
import gsap from 'gsap/all'

class Webgl extends component() {
  init() {
    this.loaded = false
    this.appended = false
  }

  appendCanvas() {
    if (!this.appended) {
      document.body.appendChild(renderer.domElement)

      gsap.fromTo(renderer.domElement, {
        autoAlpha: 0,
      }, {
        delay: 1,
        duration: 2,
        autoAlpha: 1,
      })

      this.appended = true
    }
  }

  onRemoveCanvas() {
    if (this.appended) {
      document.body.removeChild(renderer.domElement)
      this.appended = false
    }
  }

  // onEnterSite() {
  //   assets.load()
  // }

  onLoadEnd() {
    // const { camera } = world
  }

  onRaf() {
    if (world.camera) {
      const { camera: anotherCamera } = world
      postfx.render(scene, anotherCamera)
    }

    // else if (!world.visible) {
    //   postfx.render(scene, camera)
    // }
  }

  async onLoadEnd() {
    this.appendCanvas()
    this.loaded = true
  }

  destroy() {
    raf.pause()
    document.body.removeChild(renderer.domElement)
  }
}

export default new Webgl()